<style>
  .popup-close {
    background-color: #00aeab;
    border-color: #000000;
    border-style: solid;
    border-width: 2px;
    color: #ffffff;
  }
</style>
<h2 mat-dialog-title>{{ data.dialogtitle }}</h2>
<mat-dialog-content [innerHTML]="data.dialogtext"></mat-dialog-content>
<mat-dialog-actions>
  <mat-dialog-actions>
    <mat-dialog-actions align="end">
      <button class="popup-close" mat-button mat-dialog-close>Close</button>
    </mat-dialog-actions></mat-dialog-actions
  ></mat-dialog-actions
>